module.exports = __webpack_public_path__ + "img/liftIcon18.3b53911d.png";